// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  ======================

    - *** NOTICE ***
    - This file will be imported into lots of pages and components and needs to be kept as lean as possible
    - *** NOTICE ***

    - Transition docs:
    - The styling here is currently only for the basic set of tabs and tab panes...
    - If other types of tab styling are needed from the UX repo, pull them in on an as needed basis
    - Most of the styling for pre-existing tabs can be found in app.global.css and lib.bootstrap.css
    - Modify any kabob-cased classnames to camelCased
    - Change and hex color value(#222) to use the correct color variable(blue_var(--color-primary))
    - In the UX repo, many times there are duplicate slectors in the same file, search for duplicates and merge them together...
    - > remember in CSS, the last declaration wins, so if there's conflicting declarations inside of duplicate selector blocks, use the last one in the file

    ====================== */

        /*  ======================
        Component styles on page load
        ====================== */

    .Tabs_disabled__h4Hup {
        pointer-events: none;
        opacity: 0.5;
    }

    .Tabs_nav__D81oY {
        margin-bottom: 20px;
        margin-left: 0;
        list-style: none;
    }

    .Tabs_navTabs__XsX9- {
        display: flex;
        align-items: flex-end;
        border-bottom: 1px solid var(--color-107);
    }

    .Tabs_navTabs__XsX9- li .Tabs_tabTitle__qg-IF {
        display: block;
        margin: 0;
        padding: 7.5px 10px;
        line-height: 22px;
        border-radius: 0;
        border: none;
        border-bottom: 2px solid transparent;
        color: var(--color-text-medium);
        background-color: transparent;
    }

    .Tabs_navTabs__XsX9- > li,
    .Tabs_navTabs__XsX9- > li.Tabs_active__WMhjA {
        padding-left: 1px;
        padding-right: 1px;
        margin-bottom: -1px;
    }

    .Tabs_navTabs__XsX9- > .Tabs_active__WMhjA {
        border-left: none;
        border-right: none;
    }

    .Tabs_alignRight__k9gWt  {
        margin-left: auto;
    }

    .Tabs_fullWidth__odcWn{
        width: 100%;
        text-align: center;
    }

    /*  ======================
        Component styles on hover, active, focus, etc.
        ====================== */
    .Tabs_nav__D81oY > li > .Tabs_tabTitle__qg-IF:hover,
    .Tabs_nav__D81oY > li > .Tabs_tabTitle__qg-IF:focus {
        text-decoration: none;
        background-color: var(--color-118);
    }

    .Tabs_navTabs__XsX9-:before,
    .Tabs_navTabs__XsX9-:after {
      display: table;
      line-height: 0;
      content: "";
    }

    .Tabs_navTabs__XsX9- > li > .Tabs_tabTitle__qg-IF:hover,
    .Tabs_navTabs__XsX9- > li > .Tabs_tabTitle__qg-IF:focus,
    .Tabs_navTabs__XsX9- > .Tabs_active__WMhjA > .Tabs_tabTitle__qg-IF,
    .Tabs_navTabs__XsX9- > .Tabs_active__WMhjA > .Tabs_tabTitle__qg-IF:hover,
    .Tabs_navTabs__XsX9- > .Tabs_active__WMhjA > .Tabs_tabTitle__qg-IF:focus {
        color: var(--color-icon-secondary-dark);
        cursor: default;
        border-top: none;
        border-right: transparent;
        border-bottom: 2px solid var(--color-primary);
        border-left: transparent;
    }

    .Tabs_navTabs__XsX9- li .Tabs_tabTitle__qg-IF:hover,
    .Tabs_navTabs__XsX9- li .Tabs_tabTitle__qg-IF:focus {
        color: var(--color-icon-secondary-dark);
        border-bottom: 2px solid var(--color-102);
        background-color: transparent;
        cursor: pointer;
    }

    .Tabs_hiddenNavTab__7dDLf{
        display: none;
    }`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Tabs/Tabs.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;4BAe4B;;QAEpB;;gCAEwB;;IAE5B;QACI,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,qBAAqB;QACrB,yCAAyC;IAC7C;;IAEA;QACI,cAAc;QACd,SAAS;QACT,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,oCAAoC;QACpC,+BAA+B;QAC/B,6BAA6B;IACjC;;IAEA;;QAEI,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;;gCAE4B;IAC5B;;QAEI,qBAAqB;QACrB,kCAAkC;IACtC;;IAEA;;MAEE,cAAc;MACd,cAAc;MACd,WAAW;IACb;;IAEA;;;;;QAKI,uCAAuC;QACvC,eAAe;QACf,gBAAgB;QAChB,yBAAyB;QACzB,6CAA6C;QAC7C,wBAAwB;IAC5B;;IAEA;;QAEI,uCAAuC;QACvC,yCAAyC;QACzC,6BAA6B;QAC7B,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB","sourcesContent":["/*  ======================\n\n    - *** NOTICE ***\n    - This file will be imported into lots of pages and components and needs to be kept as lean as possible\n    - *** NOTICE ***\n\n    - Transition docs:\n    - The styling here is currently only for the basic set of tabs and tab panes...\n    - If other types of tab styling are needed from the UX repo, pull them in on an as needed basis\n    - Most of the styling for pre-existing tabs can be found in app.global.css and lib.bootstrap.css\n    - Modify any kabob-cased classnames to camelCased\n    - Change and hex color value(#222) to use the correct color variable(blue_var(--color-primary))\n    - In the UX repo, many times there are duplicate slectors in the same file, search for duplicates and merge them together...\n    - > remember in CSS, the last declaration wins, so if there's conflicting declarations inside of duplicate selector blocks, use the last one in the file\n\n    ====================== */\n\n        /*  ======================\n        Component styles on page load\n        ====================== */\n\n    .disabled {\n        pointer-events: none;\n        opacity: 0.5;\n    }\n\n    .nav {\n        margin-bottom: 20px;\n        margin-left: 0;\n        list-style: none;\n    }\n\n    .navTabs {\n        display: flex;\n        align-items: flex-end;\n        border-bottom: 1px solid var(--color-107);\n    }\n\n    .navTabs li .tabTitle {\n        display: block;\n        margin: 0;\n        padding: 7.5px 10px;\n        line-height: 22px;\n        border-radius: 0;\n        border: none;\n        border-bottom: 2px solid transparent;\n        color: var(--color-text-medium);\n        background-color: transparent;\n    }\n\n    .navTabs > li,\n    .navTabs > li.active {\n        padding-left: 1px;\n        padding-right: 1px;\n        margin-bottom: -1px;\n    }\n\n    .navTabs > .active {\n        border-left: none;\n        border-right: none;\n    }\n\n    .alignRight  {\n        margin-left: auto;\n    }\n\n    .fullWidth{\n        width: 100%;\n        text-align: center;\n    }\n\n    /*  ======================\n        Component styles on hover, active, focus, etc.\n        ====================== */\n    .nav > li > .tabTitle:hover,\n    .nav > li > .tabTitle:focus {\n        text-decoration: none;\n        background-color: var(--color-118);\n    }\n\n    .navTabs:before,\n    .navTabs:after {\n      display: table;\n      line-height: 0;\n      content: \"\";\n    }\n\n    .navTabs > li > .tabTitle:hover,\n    .navTabs > li > .tabTitle:focus,\n    .navTabs > .active > .tabTitle,\n    .navTabs > .active > .tabTitle:hover,\n    .navTabs > .active > .tabTitle:focus {\n        color: var(--color-icon-secondary-dark);\n        cursor: default;\n        border-top: none;\n        border-right: transparent;\n        border-bottom: 2px solid var(--color-primary);\n        border-left: transparent;\n    }\n\n    .navTabs li .tabTitle:hover,\n    .navTabs li .tabTitle:focus {\n        color: var(--color-icon-secondary-dark);\n        border-bottom: 2px solid var(--color-102);\n        background-color: transparent;\n        cursor: pointer;\n    }\n\n    .hiddenNavTab{\n        display: none;\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabled": `Tabs_disabled__h4Hup`,
	"nav": `Tabs_nav__D81oY`,
	"navTabs": `Tabs_navTabs__XsX9-`,
	"tabTitle": `Tabs_tabTitle__qg-IF`,
	"active": `Tabs_active__WMhjA`,
	"alignRight": `Tabs_alignRight__k9gWt`,
	"fullWidth": `Tabs_fullWidth__odcWn`,
	"hiddenNavTab": `Tabs_hiddenNavTab__7dDLf`
};
export default ___CSS_LOADER_EXPORT___;
